import type { LinkingOptions } from '@react-navigation/native';
import { getStateFromPath } from '@react-navigation/native';

import { getParamsFromBigBrowseUrl } from './urlUtils';

import type { RootStackParamList } from '~types/navigation';
import { RouteNames } from '~types/navigation';

export const linking2: LinkingOptions<RootStackParamList> = {
  prefixes: ['https://ownabledigital.com', 'ownabledigital://'],
  config: {
    screens: {
      [RouteNames.BigBrowse]: 'bb/:journey/:journeyParam?',
      [RouteNames.ChangePassword]: 'changePassword/:token',
    },
  },
  getStateFromPath(path, options?) {
    const params = getParamsFromBigBrowseUrl(path);

    if (path.includes('brandconcession') || path.includes('productset')) {
      return {
        routes: [
          {
            name: RouteNames.BigBrowse,
            path: '/bb/floor',
          },
          {
            name: RouteNames.BigBrowse,
            path,
            params,
          },
        ],
      };
    }

    return getStateFromPath(path, options);
  },
};
